export default __webpack_public_path__ + "static/demo-5abee92e3eba08761c65f3b9197ef4b4.png";